export const GET_DATA_MENU = 'GET_DATA_MENU'
export const GET_DATA_MENU_CLONE = 'GET_DATA_MENU_CLONE'
export const GET_DATA_MENU_PROFILE_TYPES_CLONE = 'GET_DATA_MENU_PROFILE_TYPES_CLONE'
export const GET_DATA_MENU_MODULE_CLONE = 'GET_DATA_MENU_MODULE_CLONE'
export const LOADING_DATA_MENU = 'LOADING_DATA_MENU'